var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalendarWhite = function SvgIconCalendarWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 1a.5.5 0 0 0-.5.5V3H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-1V1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3H5V1.5a.5.5 0 0 0-.5-.5h-1ZM13 8H3v4.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V8Z",
    fill: "#fff"
  })));
};
export default SvgIconCalendarWhite;